import { Component, Inject, TemplateRef, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { FooterModule, ModalComponent, ModalModule, ModalResult } from '@michelin/theme';
import { TranslationService } from '../../translations/services/translation.service';

@Component({
  selector: 'app-custom-modal-popup',
  standalone: true,
  imports: [MatDialogActions, MatDialogContent, MatButton, FooterModule, ModalModule],
  templateUrl: './custom-modal-popup.component.html',
  styleUrl: './custom-modal-popup.component.scss'
})
export class CustomModalPopupComponent {
  loginName = '';
  resetPasswordConfirmationText: string;
  resetPasswordText: string;
  @ViewChild('resetPasswordModal', { static: true }) resetPasswordModal: ModalComponent;
  @ViewChild('resetPasswordConfirmation', { static: true }) resetPasswordContentModal: TemplateRef<any>;
  @Inject(MAT_DIALOG_DATA) public data: string = inject(MAT_DIALOG_DATA);
  private dialogRef: MatDialogRef<CustomModalPopupComponent> = inject(MatDialogRef<CustomModalPopupComponent>);
  public translationService: TranslationService = inject(TranslationService);

  constructor() {
    this.loginName = this.data;
    this.resetPasswordConfirmationText = this.translationService.translate('restPasswordConfirmText') + '{user}?';
  }
  confirmResetPassword(): void {
    this.resetPasswordText = this.resetPasswordConfirmationText.replace('{user}', `<strong>${this.loginName}</strong>`);
    this.resetPasswordModal.open({
      id: this.loginName,
      width: 750,
      title: this.translationService.translate('resetPasswordText'),
      content: this.resetPasswordContentModal,
      confirm: {
        text: this.translationService.translate('resetPasswordText'),
        color: 'primary'
      },
      cancel: this.translationService.translate('cancelLinkText')
    });
  }

  onResetPasswordModalClosed(result: ModalResult) {
    if (result && result.result) {
      this.dialogRef.close('reset');
    } else {
      this.dialogRef.close('');
    }
  }

  unlockUserAccount(): void {
    this.dialogRef.close('unlock');
  }
  cancelUnlockAccount() {
    this.dialogRef.close('');
  }
}
